export interface HeaderContent {
  heading?: string;
  subHeading?: string;
}

import React from "react";
import { useSurvey } from "./SurveyContext";
import { HeaderProps } from "./types";
import TopBar from "../../../../components/Modules/TopBar";

export const Header: React.FC<HeaderProps> = ({ headers, style = {} }) => {
  const {
    Headers: contextHeaders,
    themeManager,
    currentSection = 0,
    onCancel
  } = useSurvey();

  const getCurrentHeader = (): HeaderContent => {
    if (headers && Array.isArray(headers)) {
      return headers[currentSection] || {};
    }

    if (contextHeaders) {
      if (Array.isArray(contextHeaders)) {
        return contextHeaders[currentSection] || {};
      }
      return contextHeaders;
    }

    return {};
  };

  const { heading = "", subHeading = "" } = getCurrentHeader();

  const themeStyles = themeManager.getTopBarStyles();

  return (
    <TopBar
      heading={heading}
      description={subHeading}
      onClose={onCancel}
      style={{
        ...themeStyles,
        ...style,
        headingStyle: {
          ...themeStyles.headingStyle,
          ...style.headingStyle,
        },
        descriptionStyle: {
          ...themeStyles.descriptionStyle,
          ...style.descriptionStyle,
        },
        topbarStyle: {
          ...themeStyles.topbarStyle,
          ...style.containerStyle,
        },
      }}
    />
  );
};
